import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import Input from './componentsFinance/common/Input'
import Button from './componentsFinance/common/Button'
import Checkbox from './common/Checkbox'
import { domain } from '../utils/request'
import { validateFile } from '../utils/validators'

export default function ManthlyIncomeQuarterlyItemForm({
    onCancel,
    loading,
    initialValues,
    incomeQuarterlyId,
    finance,
    onSubmit,
}) {
    const [file, setFile] = useState(null)

    async function onSuccess(data) {
        const newData = new FormData()
        if (file) {
            newData.append('incomeQuarterlyPdf', file, file.name)
        }
        newData.append('finance', finance.id)
        newData.append('incomeQuarterly', incomeQuarterlyId)
        newData.append('incomeQuarterlyComment', data.incomeQuarterlyComment)
        newData.append('tax', data.tax)
        newData.append('inps', data.inps)

        onSubmit(newData)
    }


    return (
        <Formik onSubmit={onSuccess}
            initialValues={{
                incomeQuarterlyComment: '',
                inps: false,
                tax: false,
                ...initialValues,
                incomeQuarterlyPdf: initialValues && !isEmpty(initialValues.incomeQuarterlyPdf) ? initialValues.incomeQuarterlyPdf : '',
            }} validate={validateFile('incomeQuarterlyPdf')}>
            {({
                setFieldValue, errors, touched,
            }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Input
                                name="incomeQuarterlyComment"
                                label="Комментарий"
                                disabled={loading}
                                placeholder="Комментарий" />
                        </div>

                    </div>

                    <Checkbox
                        name="tax"
                        label="Солиқлар тўланиши"
                        disabled={loading}
                        placeholder="Комментарий" />

                    <Checkbox
                        name="inps"
                        label="ИНПС реестр"
                        disabled={loading}
                        placeholder="Комментарий" />


                    <div className="columns">
                        <div className="column">
                            <p className="level-left">
                            Фойда солиғи
                            </p>

                            <input
                                onChange={(e) => {
                                    setFieldValue('incomeQuarterlyPdf', e.target.value)
                                    setFile(e.target.files[0])
                                }}
                                disabled={loading}
                                name="pdf"
                                type="file" />
                            {errors.incomeQuarterlyPdf && touched.incomeQuarterlyPdf && (
                                <div className="has-text-danger">{errors.incomeQuarterlyPdf}</div>
                            )}
                            {initialValues ? (domain + initialValues.incomeQuarterlyPdf).split('/').pop() : ''}
                        </div>

                    </div>

                    <Button
                        loading={loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" /> &nbsp;

                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text="Отмена"
                        className="is-danger" />
                </Form>
            )}
        </Formik>
    )
}
